import React, { useEffect, useState } from 'react'
import { Row, Col, Avatar, Form } from "antd";
import { CameraOutlined } from '@ant-design/icons';
import { Button, TextField, Text } from '..';
import { FaArrowLeftLong } from "react-icons/fa6";
import LabelWithField from '../LabelWithField';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { AddUserSchema, UserSignin } from '../../config/Schema';
import LabelWithSelect from '../LabelWithSelect';
import { FaPlus } from "react-icons/fa6";
import { ApiCaller, Colors, Utils } from '../../config';
import CheckBoxField from '../Select/Checkbox';
import QRCode from "react-qr-code";
import BasicDrawer from '../Drawer';
import { AddCheckPoints } from '../../config/Schema';
import { useNavigate } from 'react-router-dom';
import CheckPointForm from '../DrawerForms/checkpoint';
import { useMutation, useQuery } from 'react-query';
import { getAddresses, getIncidents } from '../../config/getApis';
import { UseDispatch, useDispatch, useSelector } from 'react-redux';
import { SiteManagementAction } from '../../store/actions';
import Circular from '../Loader/Circular';


const CheckPoint = ({
    nextStep,
    previousStep,
    currenStep

}) => {

    const [qrValue, setQrValue] = useState('')
    const [openDrawer, setOpenDrawer] = useState(false);

    // # CASE  
    // have to call the cleaner function because whenever the component render it gets the data from
    // which was previously stored in reducer. Case because if user is in the middle of the form and 
    // clicks to navigate to somewhere else the cleaner function will not going to call on that situation
    // it was getting called only on save btn and continue btn, So thats why it will get the data whenever
    // the component get render so to avoid that we called this function in useEffect whenever the 
    // component get first render on mounting stage this will trigger and by chance if any state is there
    // in reducer it will clear it.
    useEffect(() => {
        dispatch(SiteManagementAction.GetCheckPointDataCleaner())
    }, [])

    const [checkPointEditData, setCheckPointEditData] = useState({});
    const [codeValue, setCodeValue] = useState('')

    const [btnDisabled, setBtnDisabled] = useState({
        next: false,
        save: false,
        addMore: false
    })

    const { data: incidentOptions } = useQuery('incidentsOpt', getIncidents, {
        enabled: currenStep == 6
    });

    const { data: addressOptions } = useQuery('addressOpt', getAddresses, {
        enabled: currenStep == 6
    })


    const navigate = useNavigate();
    const dispatch = useDispatch();

    const checkPointsData = useSelector(state => state?.SiteManagementReducer?.checkPointData);
    const checkPointsLoader = useSelector(state => state?.SiteManagementReducer?.loader);


    const onCloseDrawer = () => {
        setOpenDrawer(false)
    }

    const schema = AddCheckPoints;

    const defaultValues = {
        name: '',
        location: '',
        code: '',
        addressId: '',
        unit: '',
        propertiesIncidentTypesId: '',
        reportNotes: '',
        officerNotes: ''
    }


    const { handleSubmit, control, reset, setValue, watch, getValues } = useForm(
        {
            resolver: yupResolver(schema),
            mode: 'onChange',
            defaultValues: defaultValues
        }
    )



    const checkPointMutation = useMutation(async (data) => {
        const { btnName, ...restData } = data;

        try {
            const id = localStorage.getItem('PropertyKey');
            let res = await ApiCaller.Post(`/property/${id}/check-point`, restData);

            if (btnName == 'next') {
                dispatch(SiteManagementAction.GetCheckPointDataCleaner())
                setBtnDisabled({
                    save: false,
                    next: false,
                    addMore: false

                });
                reset(defaultValues)
                setCodeValue('')
                nextStep();
            }

            else if (btnName == 'save') {
                dispatch(SiteManagementAction.GetCheckPointDataCleaner())
                localStorage.removeItem('PropertyKey')
                setBtnDisabled({
                    save: false,
                    next: false,
                    addMore: false

                })
                reset(defaultValues)
                setCodeValue('')
                navigate('/site-management')
            }

            else if (btnName == 'more') {
                setBtnDisabled({
                    save: false,
                    next: false,
                    addMore: false

                })
                dispatch(SiteManagementAction.GetCheckPoints(res?.data?.data?.checkPoints))
                reset(defaultValues)
                setCodeValue('')
            }
        }

        catch (err) {
            Utils.showMessage('error', err?.response?.data?.message);
            setBtnDisabled({
                save: false,
                next: false,
                addMore: false
            })
            return
        }
    })

    const nextHandler = (data, name) => {
        // post api hit and continue
        setBtnDisabled({
            save: false,
            addMore: false,
            next: true
        })

        data.btnName = name;
        data.code = codeValue
        checkPointMutation.mutate(data)
    }

    const skipHandler = () => {
        setBtnDisabled({
            next: false,
            save: false,
            addMore: false
        })
        nextStep()
        reset(defaultValues)
        setCodeValue('')
    }

    const saveHandler = (data, name) => {
        // post api hit and back to listing.
        setBtnDisabled({
            addMore: false,
            next: false,
            save: true
        })

        data.code = codeValue
        data.btnName = name;
        checkPointMutation.mutate(data)
    }

    const EditDrawerHandler = (checkpoint) => {
        setOpenDrawer(true)
        setCheckPointEditData(checkpoint)
    }


    const SaveAndAddMoreHandler = (data, name) => {
        setBtnDisabled({
            next: true,
            save: true,
            addMore: true
        })
        data.code = codeValue
        data.btnName = name
        checkPointMutation.mutate(data)
    }

    const codeHandler = (e) => {
        let query = e?.target.value;
        // setting qr value
        setCodeValue(query)
    }

    return (
        <div className='bg-white'>

            {
                !checkPointsLoader ?

                    checkPointsData?.map((checkPoint) => {
                        return (
                            <Row gutter={16} className='px-4 md:px-10 mb-2' key={checkPoint?.id}>
                                <Col span={24} className='gry-bg p-6 rounded-lg'>
                                    <Row className='px-2'>
                                        <Col lg={7} md={7} sm={24} xs={24} className='mb-2'>
                                            <Text.Label
                                                text={'CheckPoint Name'}
                                            />
                                            <p className='text-xs'>{checkPoint?.name}</p>
                                        </Col>
                                        <Col lg={7} md={7} sm={24} xs={24} className='mb-2'>
                                            <Text.Label
                                                text={'CheckPoint Location'}
                                            />
                                            <p className='text-xs'>{checkPoint?.location}</p>
                                        </Col>

                                        <Col lg={7} md={7} sm={24} xs={24} className='mb-2'>
                                            <Text.Label
                                                text={'Checkpoint Incident Type'}
                                            />
                                            <p className='text-xs'>{checkPoint?.incidentType?.name}</p>
                                        </Col>

                                        <Col lg={3} md={3} sm={24} xs={24}>
                                            <Button.Basic
                                                // onClick={() => }
                                                className="w-full h-10 yellow-bg border-none text-white border-transparent"
                                                text={"Edit"}
                                                onClick={() => EditDrawerHandler(checkPoint)}
                                            />
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>

                        )
                    })

                    :
                    <Circular
                        spinning={checkPointsLoader}
                        size={40}
                        color={Colors.Yellow}
                        containerStyle={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    />
            }


            <Row className='px-2 md:px-10'>
                <form layout="vertical" className='w-full'>
                    <Row gutter={16}>
                        <Col lg={12} xs={24}>
                            <Controller
                                control={control}
                                name='name'
                                defaultValue={''}
                                render={({ field, fieldState }) => (
                                    <>
                                        <LabelWithField
                                            labeltext={'Checkpoint Name'}
                                            field={field}
                                            labelClass={'font-normal'}
                                            inputClass={'h-10 rounded outline-none'} />
                                        {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                    </>
                                )}
                            />
                        </Col>
                        <Col lg={12} xs={24}>
                            <Controller
                                control={control}
                                defaultValue={''}
                                name='location'
                                render={({ field, fieldState }) => (
                                    <>
                                        <LabelWithField
                                            labeltext={'Checkpoint Location'}
                                            field={field}
                                            labelClass={'font-normal'}
                                            inputClass={'h-10 rounded outline-none'} />
                                        {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                    </>
                                )}
                            />
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col lg={9} xs={24}>

                            <Controller
                                control={control}
                                defaultValue={''}
                                name='code'
                                render={({ field: { value, onChange }, fieldState }) => (
                                    <>
                                        <div className="flex flex-col py-4 w-full">
                                            <label
                                                className={'font-normal'}
                                                style={{ color: Colors.LabelColor }}
                                            >
                                                QR/NFC Code Value
                                            </label>
                                            <input type={'text'}
                                                value={codeValue}
                                                onChange={codeHandler}
                                                className={`pl-2.5 outline-none h-10 rounded outline-none`}
                                                style={{ background: Colors.LightGray }}
                                            />
                                        </div>
                                        {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                    </>
                                )}
                            />
                        </Col>
                        <Col lg={3} xs={24}>
                            <QRCode value={codeValue} size={80} className='ml-2 sm:ml-6 mt-4' />
                        </Col>

                        <Col lg={12} xs={24}>
                            <Controller
                                control={control}
                                defaultValue={''}
                                name='addressId'
                                render={({ field, fieldState }) => (
                                    <>
                                        <LabelWithSelect
                                            options={addressOptions}
                                            labeltext={'Property Address'}
                                            field={field}
                                            labelClass={'font-normal'}
                                            inputClass={'outline-none h-10 rounded'}
                                        />
                                        {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                    </>
                                )}
                            />
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col lg={12} xs={24}>
                            <Controller
                                control={control}
                                defaultValue={''}
                                name='unit'
                                render={({ field, fieldState }) => (
                                    <>
                                        <LabelWithField
                                            labeltext={'Checkpoint Units'}
                                            field={field}
                                            labelClass={'font-normal'}
                                            inputClass={'h-10 rounded outline-none'} />
                                        {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                    </>
                                    // <>
                                    //     <LabelWithSelect
                                    //         options={checkPointsUnitOptions}
                                    //         labeltext={'Checkpoint Units'}
                                    //         field={field}
                                    //         labelClass={'font-normal'}
                                    //         inputClass={'outline-none h-10 rounded'}
                                    //     />
                                    //     {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                    // </>
                                )}
                            />
                        </Col>

                        <Col lg={12} xs={24}>
                            <Controller
                                control={control}
                                defaultValue={''}
                                name='propertiesIncidentTypesId'
                                render={({ field, fieldState }) => (
                                    <>
                                        <LabelWithSelect
                                            options={incidentOptions}
                                            labeltext={'Checkpoint Incident Type'}
                                            field={field}
                                            labelClass={'font-normal'}
                                            inputClass={'outline-none h-10 rounded'}
                                        />
                                        {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                    </>

                                )}
                            />
                        </Col>
                    </Row>
                    <Row gutter={16} className='mt-3'>
                        <Col lg={12} xs={24}>
                            <Controller
                                control={control}
                                name='reportNotes'
                                defaultValue={''}
                                render={({ field: { value, onChange }, fieldState }) => (
                                    <>
                                        <TextField.Textarea
                                            style={{ color: Colors.LightGray }}
                                            placeholder={''}
                                            value={value}
                                            onChange={onChange}
                                            labeltext={'Report Notes'}
                                            className={'outline-none h-10 rounded'}
                                        />
                                        {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                    </>
                                )}
                            />
                        </Col>

                        <Col lg={12} xs={24}>
                            <Controller
                                control={control}
                                name='officerNotes'
                                defaultValue={''}
                                render={({ field: { value, onChange }, fieldState }) => (
                                    <>
                                        <TextField.Textarea
                                            style={{ color: Colors.LightGray }}
                                            placeholder={''}
                                            value={value}
                                            onChange={onChange}
                                            labeltext={'Officer Notes'}
                                            className={'outline-none h-10 rounded'}
                                        />
                                        {fieldState?.error && <p style={{ color: Colors.Error }}>{fieldState?.error.message}</p>}
                                    </>
                                )}
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row gutter={16}>
                        {/* for a time being it is invisible i.e it is taking a space there but not shown */}
                        <Col span={12} className='invisible'>
                            <CheckBoxField
                                label={'Auto Create Issue Type'}
                            />
                        </Col>
                        <Col span={12} className='flex align-middle justify-end items-center'>
                            <span className={`cursor-pointer hover:underline font-bold ${checkPointMutation?.isLoading && 'pointer-events-none'}`} onClick={handleSubmit((data) => SaveAndAddMoreHandler(data, 'more'))}><span className='font-bold text-base'> + </span>
                                Save And Add More
                            </span>
                        </Col>
                    </Row>
                </form>

            </Row>

            <br />

            <Row gutter={[16, 16]} className='px-2 md:px-10' >
                <Col xs={24} lg={3} className='flex align-middle items-center'
                >
                    <FaArrowLeftLong className='mr-2' />
                    <span onClick={() => previousStep()} className={`cursor-pointer ${checkPointMutation?.isLoading && 'pointer-events-none'}`}
                    >Back</span>
                </Col>
                <Col xs={24} lg={{ span: 4, offset: 9 }} >
                    <Button.Basic
                        onClick={handleSubmit((data) => saveHandler(data, 'save'))}
                        className="w-full h-12 yellow-bg border-none text-white border-transparent"
                        text={"Save"}
                        disabled={btnDisabled.next || btnDisabled.addMore ? true : false}
                        loader={btnDisabled.next || btnDisabled.addMore ? false : checkPointMutation.isLoading}
                    />
                </Col>
                <Col xs={24} lg={4} >
                    <Button.Basic
                        className="w-full h-12  orange-bg border-none text-white border-transparent"
                        onClick={handleSubmit((data) => nextHandler(data, 'next'))}
                        text={"Continue"}
                        disabled={btnDisabled.save || btnDisabled.addMore ? true : false}
                        loader={btnDisabled.save || btnDisabled.addMore ? false : checkPointMutation.isLoading}
                    />
                </Col>
                <Col xs={24} lg={4} >
                    <Button.Basic
                        className="w-full h-12 black-bg border-none text-white border-transparent"
                        onClick={skipHandler}
                        text={"Next"}
                        disabled={btnDisabled.next || btnDisabled.save || btnDisabled.addMore ? true : false}
                    />
                </Col>
            </Row>
            <br />

            <BasicDrawer
                openDrawer={openDrawer}
                title={'Edit CheckPoint'}
                onClose={() => onCloseDrawer()}
                width={'800'}
            >
                <CheckPointForm
                    checkPointEditData={checkPointEditData}
                    onCloseDrawer={onCloseDrawer}
                />
            </BasicDrawer>
        </div>
    )
}

export default CheckPoint


var checkPointsUnitOptions = [
    {
        value: 'floor 1',
        label: 'Floor 1',
    },
    {
        value: 'floor 2',
        label: 'Floor 2',
    },
    {
        value: 'floor 3',
        label: 'Floor 3',
    },

]